import type { TileGraphEdge } from "../TileGraphEdge/TileGraphEdge.type"

export type FourCharEdgeCollection = Record<'n' | 's' | 'e' | 'w', TileGraphEdge | null>

export default function createFourCharEdgeCollection(): FourCharEdgeCollection {
  return {
    n: null,
    s: null,
    e: null,
    w: null,
  }
}